import React, { Fragment } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import HistoryWithdrawalSingleSelect from "./HistoryWithdrawalSingleSelect";

const HistoryWithdrawalFilterDialog = ({ open, onClose, title, fields, values, onFieldChange, onAction }) => (
  <Dialog fullWidth maxWidth="sm" open={open} onClose={onClose}>
    <DialogTitle>{title}</DialogTitle>

    <DialogContent>
      {fields.map((field) => (
        <Fragment key={field.key}>
          <HistoryWithdrawalSingleSelect
            title={field.caption}
            values={field.options}
            value={values[field.key]}
            onChange={(value) => onFieldChange(field.key, value)}
          />
          <Divider />
        </Fragment>
      ))}
    </DialogContent>

    <DialogActions>
      <Button type="submit" onClick={onAction} color="primary">
        <FormattedMessage id="app.filter" />
      </Button>
      <Button onClick={onClose} color="default">
        <FormattedMessage id="app.close" />
      </Button>
    </DialogActions>
  </Dialog>
);

export default HistoryWithdrawalFilterDialog;
